import React, { useState, useEffect } from "react";
import {
  OverlayTrigger,
  Table,
  Tooltip,
  Modal,
  Button,
  Form,
} from "@themesberg/react-bootstrap";
import PaginationComponent from "../Pagination";
import {
  AMOUNT_TYPE,
  CURRENCY_CODES,
  statusType,
  heroPaymentStatus,
  heroPaymentStatusWithdrawl,
  tablePlayersColumns as tableHeaders,
  transactionTableHeaders,
  transactionTypes,
  walletType,
} from "../../pages/Super-Admin/TransactionsBanking/constants";
import { convertToEasternFormat } from "../../utils/dateFormatter";
import styled from "styled-components";
import {
  ActionButton,
  StyledRow,
  StyledSelect,
  TableCell,
  TruncatedSpan,
  CryptoIcon
} from "./style";
import { formatCurrency } from "../../utils/helpers";
import { TruncatedText } from "../TruncatedText";
import { capitalize } from "@mui/material";
import useCheckPermission from "../../utils/checkPermission";
import TableErrorMessage from "../TableErrorMessage";
import ConfirmationModal from "../ConfirmationModal"
import {
  withdrawlCryptoCheck, depositCryptoCheck
} from "../../pages/Super-Admin/TransactionsBanking/constants"





const TransactionsList = ({
  setPage,
  page,
  totalPages,
  limit,
  setLimit,
  transactions = [],
  transactionType = "player_transactions",
  loading = false,
  showStatusModal,
  openStatusModal,
  closeStatusModal,
  updateTransactionStatus,
  updatingStatus,
  newStatus,
  agentId,
  handleStatusChange,
  handleAgentIdChange,
  selectedTransaction,
  driversList,
  visibleColumns,
  tableMaxHeight,
  paginationRef,
  showCryptoStatusModal,
  setShowCryptoStatusModal,
  updateCryptoTransactionStatus,
  loadingCrypto,
  selectedCrypto,
  isWithdraw,
  totalCount,
  countText,
  showTotalCount,


}) => {
  const type = transactionTypes;
  const { isHidden } = useCheckPermission();

  function isCryptoStatus(status) {
    if (isWithdraw) {
      return status === 0 ? false : withdrawlCryptoCheck.includes(status)
    }
    else {
      return depositCryptoCheck.includes(status)
    }
  }

  let headers =
    visibleColumns


  const paymentMethodDisplayName = (method) => {
    if (method === 'Cash Agency') {
      return transactionType === 'withdrawal' ? 'Cash Withdrawal' : 'Cash Deposit';
    }
    return method;
  };

  const cellRenderers = {
    transactionBankingId: (txn) => <td>{txn.transactionBankingId || "NA"}</td>,
    transactionId: (txn) =>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`tooltip-agent-number-${txn.transactionId}`}>
            {txn.transactionId || "NA"}
          </Tooltip>
        }
      >


        <td style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}>



          {txn.transactionId || "NA"}



        </td>

      </OverlayTrigger>

    ,
    paymentProvider: (txn) => <td>{paymentMethodDisplayName(txn.paymentMethod) || "NA"}</td>
    // <td>{txn.paymentMethod || "NA"}</td>



    ,
    paymentMethod: (txn) => <td>{paymentMethodDisplayName(txn.paymentMethod) || "NA"}</td>,

    paymentTransactionId: (txn) => (<td>{txn.paymentTransactionId || "NA"}</td>),


    actioneeType: (txn) => <td>{txn.actioneeType || "NA"}</td>,
    actioneeEmail: (txn) => <td>{txn.actioneeEmail || "NA"}</td>,
    actioneeName: (txn) => <td>{txn.actioneeName || "NA"}</td>,
    verificationCode: (txn) => <td>{txn.verificationCode || "NA"}</td>,
    agentName: (txn) => <td>{txn.transactionAgent?.agentName || "NA"}</td>,
    beforeBalance: (txn) => <td>  {formatCurrency(txn.beforeBalance, txn.currencyCode || null)}</td>,
    contact: (txn) => {
      const phone = txn.moreDetails?.phone;
      const phoneCode = txn.moreDetails?.phoneCode;
      return (
        <td>
          {phone ? `${phoneCode ?? ''} ${phone}` : 'NA'}
        </td>
      );
    },

    pickupLocation: (txn) => {
      const location = txn.moreDetails?.pickupLocation;
      return (
        <td>
          {location || 'NA'}
        </td>
      );
    },

    currencyCode: (txn) => <td>{txn.currencyCode || "NA"}</td>,



    specialInstructions: (txn) => {
      const specialInstructions = txn.moreDetails?.specialInstructions;
      return (
        <td>
          {specialInstructions || 'NA'}
        </td>
      );
    },

    amount: (txn) => (
      <td className="">
        {txn.amount !== null && txn.amount !== undefined ? txn.amount : "-"}
      </td>
    ),

    amountType: (txn) => (
      <td>{AMOUNT_TYPE[txn.amountType]}</td>
    ),
    primaryCurrencyAmount: (txn) => (
      <td>
        {txn.primaryCurrencyAmount || "-"}
      </td>
    ),

    transactionType: (txn) => (
      <td>
        {txn.transactionType || transactionTypes.find((t) => t.value === txn.transactionType)?.label}
        {handleWalletType({
          transactionType: txn.transactionType,
          amountType: txn.amountType,
        })}
      </td>
    ),
    status: (txn) => {
      const isCrypto = txn.paymentMethod.toLowerCase() === "crypto";

      // Fix the typo: "inclues" should be "includes"
      const statusItem = !isCrypto
        ? statusType.find((type) => type.value === txn.status)
        : isWithdraw ? heroPaymentStatusWithdrawl.find((type) => type?.value?.includes(txn.status)) : heroPaymentStatus.find((type) => type?.value?.includes(txn.status))



      return (
        <td style={{ color: statusItem?.statusColor, fontWeight: "bold" }}>
          {statusItem?.label}
        </td>
      );
    },

    createdAt: (txn) => (
      <td>{convertToEasternFormat(txn.createdAt)}</td>
    ),
    action: (txn, isCrypto) => {
      const Selectedtooltip = !isCrypto
        ? statusType.find((type) => type.value === txn.status)?.tooltipText
        : isWithdraw ? heroPaymentStatusWithdrawl.find((type) => type?.value?.includes(txn.status))?.tooltipText : heroPaymentStatus.find((type) => type?.value?.includes(txn.status))?.tooltipText

      const isSpinning = isCrypto && loadingCrypto && txn.transactionBankingId === selectedCrypto?.current?.transactionBankingId;

      return (
        <td>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-${txn.transactionBankingId}`}>
                {Selectedtooltip || ""}
              </Tooltip>
            }
          >
            <ActionButton
              hidden={isHidden({
                module: { key: "TransactionsBanking", value: "U" },
              })}
              disabled={
                isCrypto
                  ? isCryptoStatus(txn.status)
                  : [1, 2, 3].includes(txn.status)
              }
              aria-label={
                statusType.find((t) => t.value === txn.status)?.tooltipText
              }
              onClick={() => {
                if (isCrypto) {
                  selectedCrypto.current = txn
                  updateCryptoTransactionStatus({ id: txn.transactionBankingId })
                } else {
                  openStatusModal({
                    transactionId: txn.transactionBankingId,
                    actioneeEmail: txn.actioneeEmail,
                    amount: txn.primaryCurrencyAmount,
                    tddAmount: txn.amount,
                    status: txn.status,
                    paymentMethod: txn.paymentMethod,
                    agentId: txn?.transactionAgent?.transactionAgentId,
                    moreDetails: txn.moreDetails,
                  });
                }
              }}
            >
              {isCrypto ? <CryptoIcon className="fas fa-sync-alt" spinning={isSpinning} /> : <i className="fas fa-edit" />}
            </ActionButton>
          </OverlayTrigger>
        </td>
      );
    }

  };


  const isChanged =
    Number(agentId) !== selectedTransaction?.agentId ||
    Number(newStatus) !== selectedTransaction?.status;


  headers = isHidden({ module: { key: "TransactionsBanking", value: "U" } })
    ? headers.filter((h) => h.label !== "Action")
    : headers;

  const handleWalletType = ({ transactionType, amountType }) => {
    if (
      [
        "addMoney",
        "removeMoney",
        "addMoneyInternal",
        "removeMoneyInternal",
      ]?.includes(transactionType)
    ) {
      return <>({walletType[amountType]})</>;
    }
  };

  const transactionDetails = [
  {
    label: "Transaction ID",
    value: selectedTransaction?.transactionId,
  },
  {
    label: "Amount (USD)",
    value: selectedTransaction?.amount?.toFixed(2),
  },
  {
    label: "Amount (TDD)",
    value: selectedTransaction?.tddAmount?.toFixed(2),
  },
];

const bankDetails =
  selectedTransaction?.moreDetails?.bankDetail ||
  selectedTransaction?.moreDetails;

if (selectedTransaction?.paymentMethod === 'Bank Transfer') {
  transactionDetails.push(
    {
      label: 'Bank Name',
      value: bankDetails?.bankName || 'NA',
    },
    {
      label: 'Branch Code',
      value: bankDetails?.brachCode || bankDetails?.rtNumber || 'NA',
    },
    {
      label: 'Account Holder',
      value: bankDetails?.accountHolderName || 'NA',
    },
    {
      label: 'Account Type',
      value: bankDetails?.userAccountType || bankDetails?.accountType || 'NA',
    },
    {
      label: 'Account Number',
      value: bankDetails?.bankAccountNumber || bankDetails?.accountNumber || 'NA',
    }
  );
}

  return (
    <>
      {visibleColumns?.length > 0 ? <div className="CustomTableWrapper">

        <div className="table-scroll-wrapper" style={{ maxHeight: tableMaxHeight }}>
          <div className="table-responsive" id={transactionType}>


            <Table striped hover size="sm" className="text-center mt-3" >
              <thead className="thead-light">
                <tr>
                  {headers.map((h, idx) => (
                    <th
                      key={`T-table_heading ${idx}`}
                      className={`${["Amount"].includes(h.label) && transactions?.count > 0 ? "" : ""}`}
                    >
                      {h.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody id={loading ? "cover-spin" : ""}>
                {!loading && transactions?.rows?.length > 0 ? (
                  transactions.rows.map((txn, rowIndex) => (
                    <tr key={rowIndex}>
                      {headers
                        .filter((col) => visibleColumns.some(vc => vc.label === col.label))
                        .map((col, colIndex) => {
                          const key = col.accessor;
                          const renderCell = cellRenderers[key];
                          const isCrypto =
                            txn.paymentMethod.toLowerCase() === "crypto" &&
                            (!isWithdraw || txn.status !== 0);

                          // const isCrypto = txn.paymentMethod.toLowerCase() === "crypto" ? isWithdraw ? txn?.status === 0 ? false : true : true   : false;
                          return renderCell ? (
                            <React.Fragment key={colIndex}>{renderCell(txn, isCrypto)}</React.Fragment>
                          ) : (
                            <td key={colIndex}>{"NA"}</td>
                          );
                        })}
                    </tr>
                  ))
                ) : (
                  !loading && (
                    <tr>
                      <td colSpan={visibleColumns.length} className="text-center text-danger py-3 text-muted">
                        No data found
                      </td>
                    </tr>
                  )
                )}
              </tbody>

            </Table>
          </div>
        </div>

        {!loading && transactions?.count > 0 && (
          <div className="pagination-wrapper" ref={paginationRef}>
            <PaginationComponent
              page={transactions?.count < page ? setPage(1) : page}
              totalPages={totalPages}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}
              totalCount={totalCount}
              countText={countText}
              showTotalCount={showTotalCount}
            />
          </div>
        )}
      </div> : <TableErrorMessage />}

      <Modal show={showStatusModal} onHide={closeStatusModal}>
        <Modal.Header closeButton>
          <Modal.Title>Update Transaction Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTransaction && (
            <>
              <Table bordered striped size="sm">
              <tbody>
                {transactionDetails.map((item) => (
                  <tr key={item.label}>
                    <th>{item.label}</th>
                    <td>{item.value ?? "NA"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>               
              <div className="d-flex flex-column gap-3">
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <StyledSelect value={newStatus} onChange={handleStatusChange}>
                    {/* {statusType
                      .filter(
                        (status) => status.value !== "" && status.value !== 3 
                      )
                      .map((status) => (
                        <option key={status.key} value={status.value}>
                          {status.label}
                        </option>
                      ))} */}
                    {statusType
                      .filter((status) => {
                        // Exclude empty values and status 3
                        if (status.value === "" || status.value === 3) {
                          return false;
                        }

                        // If crypto status, also exclude status 1
                        if (selectedTransaction?.paymentMethod?.toLowerCase() === "crypto" && status.value === 1) {
                          return false;
                        }

                        return true;
                      })
                      .map((status) => (
                        <option key={status.key} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                  </StyledSelect>
                </Form.Group>
                {transactionType === "deposit" &&
                  selectedTransaction.paymentMethod.toLowerCase() ===
                  "cash agency" && (
                    <Form.Group>
                      <Form.Label>Driver Name</Form.Label>
                      <StyledSelect
                        value={agentId}
                        onChange={handleAgentIdChange}
                      >
                        <option value="">Select driver name</option>
                        {driversList?.map(
                          ({ transactionAgentId, agentName }) => (
                            <option
                              key={transactionAgentId}
                              value={transactionAgentId}
                            >
                              {agentName}
                            </option>
                          )
                        )}
                      </StyledSelect>
                    </Form.Group>
                  )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={closeStatusModal}
            disabled={updatingStatus}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={updateTransactionStatus}
            disabled={
              updatingStatus ||
              !newStatus ||
              (transactionType === "deposit" &&
                selectedTransaction?.paymentMethod?.toLowerCase() ===
                "cash agency" &&
                !agentId) || !isChanged
            }
          >
            {updatingStatus ? "Updating..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* updateTransactionStatusStart */}

      {showCryptoStatusModal && (
        <ConfirmationModal
          setShow={setShowCryptoStatusModal}
          show={showCryptoStatusModal}
          handleYes={updateCryptoTransactionStatus}
          title={"Are you sure?"}
          subTitle={`Do you want to change the status of this crypto transaction?`}
          name={"name"}
        />
      )}
    </>
  );
};

export default TransactionsList;
